import React from 'react';
import { Redirect } from 'react-router-dom';
import { isLoginOut } from '../App';

class Logout extends React.Component {

    componentDidMount(){
        window.location.reload()
    }
    constructor(props) {
        super(props);
        localStorage.removeItem('token');
        localStorage.removeItem('userdata');
        isLoginOut()
    }
    render() {
        return <Redirect to="/"/>           
          
    }
}
export default Logout;